import { html, LitElement, css, unsafeCSS } from 'lit';

import '../components/decklist';
import '../components/comments';

import style from './user.scss';
import { getNameFromURL, getUserData, imageToEmoji, setTitle, trackPage } from '../shared/utils';
import { DATA_CLASSES } from '../data/sources';
import '../parts/card';
import '../parts/affix';
export class UserPage extends LitElement {

    static get properties() {
        return {            
            stats: Object
        }
    }

    constructor() {
        super();        
        this.user = '';     
        this.stats = null;
        this.achievement = null;
        this.userData = null;
    }

    static styles = css`
        ${unsafeCSS(style)}        
    `;

    connectedCallback() {
        super.connectedCallback();
        trackPage();
        this.user = getNameFromURL(true);       
        setTitle('User | '+this.user);
        this.loadUserData();
        this.fetchData();
    }

    async loadUserData(){
        const user = await getUserData();
        if(user){
            this.userData = user;
            this.requestUpdate();
        }
    }

    async fetchData() {                        
        if(!this.user){
            return;
        }
        let statsjson = await fetch(`./api/stats?player=${encodeURIComponent(this.user)}`);
        this.stats = await statsjson.json();                        
    }

    parseClass(name) {
        if (name === 'War')
            return 'Warrior';
        if (name === 'Arc')
            return 'Arcanist';
        if (name === 'Rog')
            return 'Rogue';
        if (name === 'Hun')
            return 'Hunter';
        if (name === 'See')
            return 'Seeker';
        if (name === 'Kni')
            return 'Knight';
        if (name === 'Sci')
            return 'Sunforge Run';
    }

    displayPercentage(top,bottom){
        return `${Math.round(top/(bottom||1)*100)}%`;
    }

    render() {              
        const totalruns = this.stats?.goodruns+this.stats?.badruns;    
        const bestcls = this.parseClass(this.stats?.classes[0]?._id);
        const cls = DATA_CLASSES.filter(c=>c.name===bestcls)[0];      
        const achievements = this.stats?.a?.filter(ac=>!ac.award);    
        const otherachievements = this.stats?.othera?.filter(ac=>!ac.award);         
        const awards = this.stats?.a?.filter(ac=>ac.award);                   
        return html`
            <h1><img loading="lazy" class="header-image" src="./images/disc.svg" alt=${this.user} /> ${this.user?.replace(/_/g,' ')}</h1>         
            ${this.userData?.username?.toLowerCase() === this.user?.toLowerCase() ? html`
            <p><a href="./auth/logout" class="button">Logout</a></p>
            `:''}    
            ${this.stats ? html`            
            <div class="bubble big">Total Runs: ${totalruns}</div>  
            <div class="bubble big">Total Duration: ${this.stats.duration.toLocaleString()} hrs</div>
            <div class="bubble big">Total Score: ${this.stats.score[0]?.total?.toLocaleString() || 0}</div>   
            ${awards?.length > 0 ? html`
            <h3>Awards (${awards?.length})</h3>
            ${awards?.map(ac=>html`
            <div class="bubble big" style="border:none;background:none;">                     
                <span style="font-size: 20px">${imageToEmoji(ac.image)}</span> 
                <b>${ac.name}</b>
            </div>  
            `)}               
            `:''}            
            <h3>Achievements (${achievements?.length}/${achievements?.length+otherachievements?.length})</h3>
            ${this.achievement?html`
            <p style="color:#ffd100;">${this.achievement.desc}</p>
            `:''}
            ${achievements?.map(ac=>html`
            <div class="bubble big" @click=${()=>{
                if(!this.achievement){
                    this.achievement=ac;
                }else{
                    this.achievement=null;
                }
                this.update();
            }} style="color:#ffd100;cursor:pointer;${this.achievement?.name === ac.name ? 'border-color: #ffd100;':''}">                    
                <div class="artwork" style="background-image:url(./images/icons/${(ac.image).replace(/ /g, '%20')}.webp);"></div>
                <b>${ac.name}</b>
            </div>  
            `)}         
            ${otherachievements?.map(ac=>html`
            <div class="bubble big" style="opacity:0.7;cursor:help;">   
                <div class="artwork" style="background-image:url(./images/events/lost%20journal.webp);"></div>                                 
                <b>${ac}</b>
            </div>  
            `)}                                  
            <h3>Most Played</h3>
            ${bestcls ? html`
            <div class="row">
                <div class="bubble big">Class</div>     
                ${cls?html`
                    <img loading="lazy" class="class-image" src='./images/classes/${cls?.artwork}.webp' alt=${cls?.name} />     
                `:html`
                    <img loading="lazy" class="class-image" src='./images/icons/cardart_5_50.webp' alt="Sunforge Run" />     
                `}                                      
                <div style="vertical-align:middle;display:inline-block">
                    ${bestcls !== 'Sunforge Run' ? html`
                        <a href="./class/${bestcls}">${bestcls}</a>
                    `:html`
                        <b>${bestcls}</b>
                    `}                    
                </div>                
                <div class="bubble">${this.displayPercentage(this.stats.classes[0]?.count,totalruns)}</div>
            </div>
            `:''}   
            ${this.stats?.cards?.length > 0 ? html`
            <div class="row">
                <div class="bubble big">Card</div>
                <card-part id=${this.stats?.cards[0]?._id}></card-part>                
                <div class="bubble">${this.displayPercentage(this.stats.cards[0]?.count,totalruns)}</div>
            </div>
            `:''}   
            ${this.stats?.talents?.length > 0 ? html`
            <div class="row">
                <div class="bubble big">Talent</div>
                <card-part id=${this.stats?.talents[0]?._id} talent="true"></card-part>                
                <div class="bubble">${this.displayPercentage(this.stats.talents[0]?.count,totalruns)}</div>
            </div>
            `:''}   
            ${this.stats?.imbues?.length > 0 ? html`
            <div class="row">
                <div class="bubble big">Imbue</div>                
                <card-part id=${this.stats?.imbues[0]?._id}></card-part>                
                <div class="bubble">${this.displayPercentage(this.stats.imbues[0]?.count,totalruns)}</div>                            
            </div>
            `:''}   
            ${this.stats?.malignances?.length > 0 ? html`
            <div class="row">
                <div class="bubble big">Malignance</div>                
                <affix-part id=${this.stats?.malignances[0]?._id}></affix-part>                
                <div class="bubble">${this.displayPercentage(this.stats.malignances[0]?.count,totalruns)}</div>                            
            </div>
            `:''}   
            `:'Loading stats...'}   
            <decklist-component url=${`userdecks/${encodeURIComponent(this.user)}`} showduration="true" title="Decks"></decklist-component> 
            <comments-component path=${window.location.pathname}></comments-component>
        `;
    }
}

customElements.define('user-page', UserPage);